var map = {
	"./Angel.jpg": 4476,
	"./Charlie.jpg": 2868,
	"./Daniel.jpg": 7572,
	"./Emily.jpg": 208,
	"./Gabriel.jpg": 2056,
	"./Jason.jpg": 999,
	"./Marcel.jpg": 7208,
	"./Rafael.jpg": 6428,
	"./Sarah.jpg": 7520,
	"./Tammy.jpg": 7076
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7084;